import { createSlice } from '@reduxjs/toolkit';

// types
import { SnackbarProps } from 'types/snackbar';
const translate = (key: string) => (window as any).translate(key);

const initialState: SnackbarProps = {
  action: false,
  open: false,
  message: 'Note archived',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  variant: 'default',
  alert: {
    color: 'primary',
    variant: 'filled',
    sx: {}
  },
  transition: 'Fade',
  close: true,
  actionButton: false,
  maxStack: 3,
  dense: false,
  iconVariant: 'usedefault'
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    openSnackbar(state, action) {
      const { open, message, anchorOrigin, variant, alert, transition, close, actionButton } = action.payload;

      state.action = !state.action;
      state.open = open || initialState.open;
      state.message = message || initialState.message;
      state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
      state.variant = variant || initialState.variant;
      state.alert = {
        color: alert?.color || initialState.alert.color,
        variant: alert?.variant || initialState.alert.variant,
        sx: alert?.sx || initialState.alert.sx
      };
      state.transition = transition || initialState.transition;
      state.close = close === false ? close : initialState.close;
      state.actionButton = actionButton || initialState.actionButton;
    },

    openDefaultSuccessSnackbar(state, action) {
      const { message, preventAutoDismiss, hideDuration } = action.payload;

      state.action = !state.action;
      state.open = true;
      state.message = message || initialState.message;
      state.anchorOrigin = { vertical: 'top', horizontal: 'right' };
      state.variant = 'alert';
      state.alert = {
        color: 'success'
      };
      state.transition = 'SlideLeft';
      state.close = true;
      state.actionButton = initialState.actionButton;
      if (preventAutoDismiss) {
        state.autoHideDuration = hideDuration ? hideDuration : null;
      } else {
        state.autoHideDuration = undefined;
      }
    },
    openDefaultInfoSnackbar(state, action) {
      const { message, preventAutoDismiss, HideDuration } = action.payload;
      state.action = !state.action;
      state.open = true;
      state.message = message ?? initialState.message;
      state.anchorOrigin = { vertical: 'top', horizontal: 'right' };
      state.variant = 'alert';
      state.alert = {
        color: 'info'
      };
      state.transition = 'SlideLeft';
      state.close = action.payload.close !== undefined ? action.payload.close : true;
      state.actionButton = false;
      state.iconVariant = 'usedefault';
      if (preventAutoDismiss) {
        state.autoHideDuration = HideDuration;
      } else {
        state.autoHideDuration = undefined;
      }
    },

    openDefaultErrorSnackbar(state, action) {
      const { message, preventAutoDismiss } = action.payload;

      state.action = !state.action;
      state.open = true;
      state.message = message || "We're sorry, but something went wrong. Please try again.";
      state.anchorOrigin = { vertical: 'top', horizontal: 'right' };
      state.variant = 'alert';
      state.alert = {
        color: 'error'
      };
      state.transition = 'SlideLeft';
      state.close = true;
      state.actionButton = initialState.actionButton;
      if (preventAutoDismiss) {
        state.autoHideDuration = null;
      } else {
        state.autoHideDuration = undefined;
      }
    },

    openDefaultInfoForApiInProgressSnackbar(state) {
      state.action = true;
      state.open = true;
      state.close = false;
      state.autoHideDuration = null;
      state.message = translate('messages.actionInProgress');
      state.anchorOrigin = { vertical: 'top', horizontal: 'right' };
      state.variant = 'alert';
      state.alert = {
        color: 'info'
      };
      state.transition = 'SlideLeft';
      state.iconVariant = 'usedefault';
      state.actionButton = false;
    },

    closeSnackbar(state) {
      delete state.autoHideDuration;
      state.open = false;
    },

    handlerIncrease(state, action) {
      const { maxStack } = action.payload;
      state.maxStack = maxStack;
    },
    handlerDense(state, action) {
      const { dense } = action.payload;
      state.dense = dense;
    },
    handlerIconVariants(state, action) {
      const { iconVariant } = action.payload;
      state.iconVariant = iconVariant;
    }
  }
});

export default snackbar.reducer;

export const {
  closeSnackbar,
  openSnackbar,
  openDefaultSuccessSnackbar,
  openDefaultErrorSnackbar,
  openDefaultInfoSnackbar,
  openDefaultInfoForApiInProgressSnackbar,
  handlerIncrease,
  handlerDense,
  handlerIconVariants
} = snackbar.actions;
